import axiosClient from '../axiosClient';

export interface AttachmentResponse {
  id: number;
  icsRowId: number;
  icsExternalId: string;
  originalFileName: string;
  safeFileName: string;
  contentType?: string;
  fileSize?: number;
  uploadedBy: string;
  uploadedAt: string;
  ics_SoftDeleted: boolean;
  ics_Deleted_By?: string;
  ics_Deleted_At?: string;
}

export interface CreateAttachmentRequest {
  tableKey: string;
  rowId: number;
  externalId: string;
  file: File;
}

// Alle paths er relative til axios baseURL (/api), så full URL blir f.eks. /api/attachment/counts

/**
 * Hent alle vedlegg for en rad
 */
export async function getAttachments (rowId: number): Promise<AttachmentResponse[]> {
  const response = await axiosClient.get<AttachmentResponse[]>(`attachment/${rowId}`);
  return response.data || [];
}

/**
 * Last opp et vedlegg
 */
export async function uploadAttachment (request: CreateAttachmentRequest): Promise<AttachmentResponse> {
  // Validering av externalId/tableKey eies av backend (returnerer 400/ProblemDetails);
  // FE pre-validerer ikke lenger, og lar BE-feil bobble opp til kalleren.
  const formData = new FormData();
  formData.append('file', request.file);
  formData.append('tableKey', request.tableKey);
  formData.append('rowId', request.rowId.toString());
  formData.append('externalId', request.externalId);

  const response = await axiosClient.post<AttachmentResponse>('attachment', formData);
  return response.data;
}

/**
 * Last ned et vedlegg
 */
export async function downloadAttachment (attachmentId: number): Promise<Blob> {
  const response = await axiosClient.get(`attachment/download/${attachmentId}`, {
    responseType: 'blob'
  });
  return response.data;
}

/**
 * Soft delete et vedlegg
 */
export async function deleteAttachment (attachmentId: number): Promise<void> {
  await axiosClient.delete(`attachment/${attachmentId}`);
}

/**
 * Hent vedleggsantall for flere rader
 */
export async function getAttachmentCounts (rowIds: number[]): Promise<Record<number, number>> {
  if (rowIds.length === 0) {
    return {};
  }

  const params = new URLSearchParams();
  rowIds.forEach(id => params.append('rowIds', id.toString()));

  const response = await axiosClient.get<Record<string, number>>(`attachment/counts?${params.toString()}`);

  // Convert string keys to numbers
  const result: Record<number, number> = {};
  Object.entries(response.data || {}).forEach(([key, value]) => {
    result[Number(key)] = value;
  });

  return result;
}
